// Centralized configuration file

// API Base URL - development uses localhost:5001, production uses same origin
const BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? "" : "http://localhost:5001");

export const API_BASE_URL = `${BASE_URL}/api`;

// Socket URL - development uses localhost:5001, production uses same origin (wss:// for HTTPS)
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  (process.env.NODE_ENV === "production"
    ? window.location.origin
    : "http://localhost:5001");

const config = {
  API_BASE_URL,
  SOCKET_URL,
};

export default config;
